<script>
	import { tick } from "svelte";

	export let id = null;
	export let label = null;
	export let value = "";
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let placeholder = null;
	export let showCents = null;

	const KEYBOARD = {
		BACKSPACE: 8,
		DELETE: 46
	};

	const handleKeyDown = (e) => {
		if (
			e.key == "Backspace" ||
			e.key == "Delete" ||
			e.key == "ArrowLeft" ||
			e.key == "ArrowRight" ||
			e.key === "Enter"
		) {
			return true;
		}
	};

	const handleKeyPress = (e) => {
		if (e.metaKey || e.altKey || e.ctrlKey || e.key === "Enter") {
			return true;
		}

		if (e.key.match(/\d/) || e.key.match(/\./)) {
			const oldValue = value ? value.toString() : null;

			if (
				!(
					oldValue &&
					oldValue.includes &&
					oldValue.includes(".") &&
					oldValue.indexOf(".") === oldValue.length - 3
				)
			) {
				return true;
			}
		}

		e.preventDefault();
		return false;
	};
</script>

{#if label}
	<label for={id} class:isrequired={required}>{label}</label>
{/if}
<div class="input-group">
	<div class="input-group-prepend">
		<span class="input-group-text">$</span>
	</div>
	<input
		{required}
		{disabled}
		{readonly}
		{id}
		bind:value
		type="number"
		class="form-control"
		{placeholder}
		data-bouncer-target=".decimal-error"
		step="any"
		on:keydown={handleKeyDown}
		on:keypress={handleKeyPress}
	/>
	<div class="decimal-error"></div>
	{#if showCents}
		<div class="input-group-append">
			<span class="input-group-text">.00</span>
		</div>
	{/if}
</div>
